import { getApiClient } from "./apiClient";

interface LoginResponse {
  user: any;
  status?: string;
  message?: string;
  contact_email?: string;
  trial_end?: string;
}

interface RegisterData {
  username: string;
  email: string;
  password: string;
  password_confirm: string;
  registration_code?: string;
  first_name?: string;
  last_name?: string;
}

class AuthService {
  async login(username: string, password: string): Promise<LoginResponse> {
    const client = await getApiClient();
    const response = await client.post("/auth/login/", {
      username,
      password,
    });
    return response.data;
  }

  async register(userData: RegisterData): Promise<LoginResponse> {
    const client = await getApiClient();
    const response = await client.post("/auth/register/", userData);
    return response.data;
  }

  async logout(): Promise<void> {
    const client = await getApiClient();
    await client.post("/auth/logout/", {});
  }

  async getProfile(): Promise<any> {
    const client = await getApiClient();
    const response = await client.get("/auth/profile/");
    return response.data;
  }

  async verifyEmail(token: string): Promise<any> {
    const client = await getApiClient();
    const response = await client.post("/auth/verify-email/", {
      token,
    });
    return response.data;
  }

  async requestPasswordReset(email: string): Promise<any> {
    const client = await getApiClient();
    const response = await client.post("/auth/request-password-reset/", {
      email,
    });
    return response.data;
  }

  async resetPassword(
    token: string,
    password: string,
    password_confirm: string,
  ): Promise<any> {
    const client = await getApiClient();
    const response = await client.post("/auth/reset-password/", {
      token,
      password,
      password_confirm,
    });
    return response.data;
  }

  async activateAccount(registrationCode: string): Promise<any> {
    const client = await getApiClient();
    const response = await client.post("/auth/activate/", {
      registration_code: registrationCode,
    });
    return response.data;
  }

  async validateInvite(token: string): Promise<{
    email: string;
    organization_name: string;
    inviter_name: string;
  }> {
    const client = await getApiClient();
    const response = await client.get(`/auth/validate-invite/?token=${token}`);
    return response.data;
  }

  async acceptInvite(data: {
    invitation_token: string;
    password: string;
    password_confirm: string;
    first_name?: string;
    last_name?: string;
  }): Promise<LoginResponse> {
    const client = await getApiClient();
    const response = await client.post("/auth/accept-invite/", data);
    return response.data;
  }
}

export const authService = new AuthService();
